import React, { useEffect, useState } from 'react';
import { StepByStep } from '@gerdau/hefesto-mais-web';
import { Step } from '@gerdau/hefesto-mais-web/StepByStep/StepByStep.types';
import { useLocation } from 'react-router-dom';
import { EConstructionRegistrationRoutes } from '../constructionRegistration.routes';
import { Container } from './styles';

const ConstructionRegistrationTabs: React.FC = () => {
  const { pathname } = useLocation();
  const [currentTab, setCurrentTab] = useState(0);

  const steps: Step[] = [
    { label: 'Dados da obra' },
    { label: 'Condições de entrega' },
    { label: 'Responsáveis pela obra' },
    { label: 'Revisão do cadastro' }
  ];

  useEffect(() => {
    const currentPath = `/${pathname.split('/').pop()}`;
    const routes: EConstructionRegistrationRoutes =
      currentPath as EConstructionRegistrationRoutes;
    updateCurrentTab(routes);
  }, [pathname]);

  const updateCurrentTab = (path: EConstructionRegistrationRoutes) => {
    const tabs: { [key in EConstructionRegistrationRoutes]: number } = {
      [EConstructionRegistrationRoutes.CONSTRUCTION_DATA]: 0,
      [EConstructionRegistrationRoutes.DELIVERY_CONDITIONS]: 1,
      [EConstructionRegistrationRoutes.RESPONSIBLE_OF_CONSTRUCTION]: 2,
      [EConstructionRegistrationRoutes.CHECKOUT]: 3,
      [EConstructionRegistrationRoutes.SUCCESS]: 4
    };
    setCurrentTab(tabs[path]);
  };

  return (
    <Container>
      <StepByStep steps={steps} activeStep={currentTab}></StepByStep>
    </Container>
  );
};

export default ConstructionRegistrationTabs;
